module.exports = __webpack_public_path__ + "static/media/donut.8b610dc5.svg";